import MomentUtils from "@date-io/moment";
import { MuiThemeProvider } from "@material-ui/core";
import { portalNews } from "constants/portalNews";
import { NewsModal } from "features/shared/components";
import Loading from "features/shared/components/Loading/LoadingContainer";
import LoadingSalvando from "features/shared/components/LoadingSalvando/LoadingSalvandoContainer";
import Notificacao from "features/shared/components/Notificacao";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import moment from "moment";
import React, { type PropsWithChildren } from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import reduxThunk from "redux-thunk";
import { useTranslations } from "./adapters/i18n";
import AppContainer from "./features/app/AppContainer";
import { NotificacaoContainer } from "./features/notificacao";
import reducers from "./redux/reducers";
import { checaESalvaLocalstorageProps } from "./shared/utils";
import Theme from "./styles/theme";

import "./adapters/i18n/i18n.config";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(reduxThunk, checaESalvaLocalstorageProps))
);

function WithProviders({ children }: PropsWithChildren<unknown>) {
  const { currentLanguage } = useTranslations();

  return (
    <Provider store={store}>
      <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <MuiThemeProvider theme={Theme}>
          <MuiPickersUtilsProvider
            utils={MomentUtils}
            locale={currentLanguage.locale}
            moment={moment}
          >
            {children}
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </CookiesProvider>
    </Provider>
  );
}

ReactDOM.render(
  <WithProviders>
    <Loading />
    <LoadingSalvando />
    <AppContainer />
    <Notificacao />
    <NotificacaoContainer />
    <NewsModal news={portalNews} />
  </WithProviders>,
  document.getElementById("root")
);
